import { Component } from '@angular/core';
@Component({
  selector: 'app-glow',
  templateUrl: './glow.component.html',
  styleUrls: ['./glow.component.scss']
})
export class GlowComponent {
}
